












































































































































































































import Vue from "vue";
import {
  ADD_ORDER_DISH,
  DELETE_ORDER_DISH,
  UPDATE_ORDER_DISH
} from "@/queries/customer/mutation.graphql";
import { GET_ORDER_DISH } from "@/queries/customer/query.graphql";
import DeleteMenuItemConfirmation from "@/views/dashboard/deleteMenuItemConfirmation.vue";
import { bus } from "@/utils/event-emitter";
export default Vue.extend({
  components: {
    DeleteMenuItemConfirmation
  },
  data() {
    return {
      quantity: 1,
      selectedModifiers: null,
      loading: false,
      selectedforUpdate: null,
      removing: false,
      openDeleteConfirmation: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String
    },
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    totalPrice(): number {
      if (!this.selectedModifiers) return 0;
      const initial = this.item ? this.item.price : 0;
      let addOns = 0;
      this.selectedModifiers.forEach(el => {
        if (typeof el.modifierItemId === "string") {
          addOns += el.itemPrice[el.modifierItemId] * el.count;
        } else if (Array.isArray(el.modifierItemId)) {
          if (el.modifierItemId.length > 0) {
            el.modifierItemId.forEach(element => {
              addOns += el.itemPrice[element] * el.count[element];
            });
          }
        }
      });
      const floatPrice: number = (initial + addOns) * this.quantity;
      return +floatPrice.toFixed(2);
    }
  },
  methods: {
    onClose() {
      if (this.loading) return;
      this.$emit("close", false);
    },
    initForAddingMode(updateMode?: boolean) {
      // if(!this.item) return [];
      this.quantity = 1;
      this.selectedModifiers = this.item.DishModifiers.map(
        (dishModifier: any) => {
          const totalMax = dishModifier.Modifier.totalMax;
          const totalMin = dishModifier.Modifier.totalMin;
          const itemMax = dishModifier.Modifier.itemMax;
          let modifierItemId;
          let count;
          let itemPrice;
          if (totalMax === 1 && totalMin !== 0) {
            modifierItemId = dishModifier.Modifier.ModifierItems[0].id;
            count = 1;
            itemPrice = {};
            dishModifier.Modifier.ModifierItems.forEach(element => {
              itemPrice[element.id] = element.price;
            });
          } else if (totalMax === 1 && totalMin === 0) {
            modifierItemId = [];
            count = {};
            itemPrice = {};
            dishModifier.Modifier.ModifierItems.forEach(element => {
              count[element.id] = 1;
              itemPrice[element.id] = element.price;
            });
          } else if (totalMax > 1) {
            count = {};
            itemPrice = {};
            dishModifier.Modifier.ModifierItems.forEach(element => {
              count[element.id] = 1;
              itemPrice[element.id] = element.price;
            });
            modifierItemId =
              totalMin === 0 || updateMode
                ? []
                : [dishModifier.Modifier.ModifierItems[0].id];
          }
          return {
            modifierItemId,
            count,
            itemPrice
          };
        }
      );
    },
    onSelect(index, modifierItemId) {
      if (modifierItemId) {
        this.selectedModifiers[index].count[modifierItemId] = 1;
        return;
      }
      this.selectedModifiers[index].count = 1;
    },
    prepareRequestVariables() {
      const variables = {
        count: this.quantity,
        dishId: this.item.id
      };
      const modifierItems = [];
      this.selectedModifiers.forEach(el => {
        if (typeof el.modifierItemId === "string") {
          const { itemPrice, ...rest } = el;
          modifierItems.push({ ...rest });
        } else if (Array.isArray(el.modifierItemId)) {
          if (el.modifierItemId.length > 0) {
            el.modifierItemId.forEach(element => {
              modifierItems.push({
                modifierItemId: element,
                count: el.count[element]
              });
            });
          }
        }
      });
      variables["modifierItems"] = modifierItems;
      return variables;
    },
    addOrUpdate() {
      if (this.mode) {
        this.updateOrderDish();
      } else {
        this.addOrderDish();
      }
    },
    updateOrderDish() {
      const variables = this.prepareRequestVariables();
      variables["id"] = this.selectedforUpdate.id;
      variables["modifierItems"] = variables["modifierItems"].map(el => ({
        ...el,
        orderDishId: this.selectedforUpdate.id
        // dishId: this.selectedforUpdate.dishId,
      }));
      variables["itemsIds"] = variables["modifierItems"].map(
        el => el.modifierItemId
      );
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_ORDER_DISH,
          variables,
          update: (cache, { data: { c } }) => {
            if (c) {
              const data: any = cache.readQuery({
                query: GET_ORDER_DISH
              });
              const index = data.OrderDish.findIndex(
                el => el.id === c.returning[0].id
              );
              (data.OrderDish as Array<any>).splice(index, 1, c.returning[0]);
              cache.writeQuery({
                query: GET_ORDER_DISH,
                data
              });
            }
          }
        })
        .then(data => {
          this.loading = false;
          this.onClose();
        })
        .catch(error => (this.loading = false));
    },
    addOrderDish() {
      const variables = this.prepareRequestVariables();
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ADD_ORDER_DISH,
          variables,
          update: (cache, { data: { insert_OrderDish } }) => {
            if (insert_OrderDish) {
              const data: any = cache.readQuery({
                query: GET_ORDER_DISH
              });
              data.OrderDish.push(insert_OrderDish.returning[0]);
              cache.writeQuery({
                query: GET_ORDER_DISH,
                data
              });
            }
          }
        })
        .then(data => {
          this.loading = false;
          this.onClose();
        })
        .catch(error => (this.loading = false));
    },
    async deleteOrderDish() {
      this.removing = true;
      this.openDeleteConfirmation = false;
      const { data, errors } = await this.$apollo.mutate({
        mutation: DELETE_ORDER_DISH,
        variables: {
          orderModifierItemId: [],
          orderDishId: this.selectedforUpdate.id
        },
        update: (cache, { data: { a, b } }) => {
          if (b.affected_rows) {
            const data: any = cache.readQuery({
              query: GET_ORDER_DISH
            });
            data.OrderDish = data.OrderDish.filter(
              el => el.id !== this.selectedforUpdate.id
            );
            cache.writeQuery({
              query: GET_ORDER_DISH,
              data
            });
          }
        }
      });
      this.removing = false;
      if (data) {
        this.onClose();
      }
    }
  },
  created() {
    bus.$on("edit-order-dish", data => {
      this.$watch("show", () => {
        this.selectedforUpdate = data;
        this.initForAddingMode(true);
        this.quantity = data.count;
        data.OrderDishModifierItems.forEach((element: any) => {
          const modifierItemId = element.ModifierItem.id;
          this.selectedModifiers.forEach(elm => {
            const itemsForModifier = Object.keys(elm.itemPrice);
            if (itemsForModifier.includes(modifierItemId)) {
              if (typeof elm.modifierItemId === "string") {
                elm.modifierItemId = modifierItemId;
                elm.count = element.count;
              } else if (Array.isArray(elm.modifierItemId)) {
                elm.modifierItemId.push(modifierItemId);
                elm.count[modifierItemId] = element.count;
              }
            }
          });
        });
      });
      //dsfsdf
    });
  },
  watch: {
    show() {
      if (this.show && !this.mode) {
        this.initForAddingMode();
      }
    }
  }
});
